import React from 'react';
import { Worker, Viewer } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';

interface IMGModalProps {
    fileUrl: string;
    onClose: () => void;
}

const IMGModal: React.FC<IMGModalProps> = ({ fileUrl, onClose }) => {
    const defaultLayoutPluginInstance = defaultLayoutPlugin();
    const handleShare = async (url: string) => {
        if (navigator.share) {
            try {
                await navigator.share({
                    title: "Imagem",
                    text: "Segue a Imagem:",
                    url: url  // usa a URL diretamente
                });
            } catch (error) {
                console.error("Erro:", error);
            }
        } else {
            alert("Compartilhamento não suportado.");
        }
    };
    return (
        <div style={overlayStyle}>
            <div style={modalStyle}>
                {/* Cabeçalho com botões */}
                <div style={headerStyle}>
                    <div>
                        <button
                            className="btn btn-success"
                            type='button'
                            onClick={()=>{handleShare(fileUrl)}}
                        >
                            Compartilhar
                        </button>
                        <a
                            href={fileUrl}
                            style={{marginLeft:5}}
                            download
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn-warning"
                        >
                            Baixar
                        </a>
                    </div>
                    <button
                        type="button"
                        className="btn btn-danger"
                        onClick={onClose}
                    >
                       X Fechar
                    </button>
                </div>

                {/* Visualizador PDF */}
                <div style={{ flex: 1, overflow: 'auto',padding:10 }}>
                    <img src={fileUrl} style={{width:'100%'}} />
                </div>
            </div>
        </div>
    );
};

const overlayStyle: React.CSSProperties = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1050,
    padding: '10px',
};

const modalStyle: React.CSSProperties = {
    backgroundColor: '#fff',
    borderRadius: '8px',
    maxWidth: '700px',
    width: '100%',
    height: '90%',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
};

const headerStyle: React.CSSProperties = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '10px',
    borderBottom: '1px solid #ddd',
    backgroundColor: '#f8f9fa',
};

export default IMGModal;
